import React, { forwardRef } from 'react';
import { Select } from 'antd';
import { RENEWAL_PERIOD } from '../config/common';

const RenewalPeriodSelect = forwardRef(({ onChange, value }, ref) => {
	return (
		<Select
			ref={ref}
			mode='single'
			optionFilterProp='label'
			onChange={onChange}
			defaultValue={value}
			placeholder='Välj förnyelseperiod'
		>
			{RENEWAL_PERIOD.LIST.map((period) => (
				<Select.Option key={period.id} value={period.id} label={period.label}>
					{period.label}
				</Select.Option>
			))}
		</Select>
	);
});

export default RenewalPeriodSelect;



// WEBPACK FOOTER //
// ./src/components/RenewalPeriodSelect.jsx